'use client'

import { useTranslation } from '../../hooks/useTranslation';
export default function Testimonials() {
  const { t } = useTranslation();
  const testimonials = [
  {
    id: 1,
    text: "Blue Road made my Dubai trip unforgettable. The Lamborghini Huracán was spotless and delivered to my hotel right on time. Their team handled everything with complete professionalism. Easily the best rental experience I've ever had.",
    name: "Alex Carter",
    rating: 5
  },
  {
    id: 2,
    text: "As a frequent business traveler, I’ve rented from many companies — but none come close to the level of service and quality that Blue Road provides. The Range Rover Sport was immaculate and made a powerful first impression for my meetings.",
    name: "Sana Al Khalidi",
    rating: 5
  },
  {
    id: 3,
    text: "I surprised my husband with a Ferrari 488 rental for our anniversary. Blue Road handled it flawlessly. The car was breathtaking, and their team was so accommodating. Highly recommend them for any special occasion.",
    name: "Mira Patel",
    rating: 5
  },
  {
    id: 4,
    text: "Top-tier cars, seamless booking, and zero stress. I reserved a Porsche 911 for a weekend drive, and the entire process was smooth. Blue Road is now my go-to in Dubai — no question.",
    name: "Daniel Hoffman",
    rating: 5
  }
];


  return (
    <section className="py-8 sm:py-12 md:py-16 bg-[var(--background)] text-white">
      <div className="md:mx-16 lg:mx-[120px] px-4 sm:px-6 md:px-8">
        {/* Header */}
        <div className="mb-8 sm:mb-10 md:mb-12">
          <div className="flex items-center mb-3 sm:mb-4">
            <div className="w-8 sm:w-10 md:w-20 h-0.5 bg-[#006FFF] mr-3 sm:mr-4"></div>
            <h2 className="text-2xl sm:text-3xl font-bold font-poppins font-medium not-italic text-[32px] leading-[100%] tracking-[0] text-center">{t('testimonial.title')}</h2>
          </div>
          <p className="text-white max-w-md text-sm leading-relaxed">
            {t('testimonial.desc')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-[#383838DB] rounded-lg p-4 sm:p-5 md:p-6 relative transition-colors duration-300">
              {/* Quote Icon */}
              <div>
                <img
                  src="/images/icons/quotes.png"
                  alt="Quote Icon"
                  className="w-[36px] mb-3"
                />
              </div>
              
              {/* Testimonial Text */}
              <p className="text-[#958F88] leading-[100%] tracking-[0%] not-italic font-light font-poppins text-[13px] leading-relaxed mb-6 sm:mb-7 md:mb-8 line-clamp-4 sm:line-clamp-none">
                {testimonial.text}
              </p>
              
              {/* Author Section */}
              <div className="flex items-center">
                <img
                  src="/images/testi.jpg"
                  alt={testimonial.name}
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover mr-3 sm:mr-4 flex-shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <h4 className="font-poppins font-normal not-italic text-[16px] leading-[100%] tracking-[0]">{testimonial.name}</h4>
                  {/* Star Rating */}
                  <div className="flex text-[#FFC14D] text-lg sm:text-sm mt-1 p-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}